export default "__VITE_ASSET__oLQLGjhY__"